import { Formik, FormikHelpers } from "formik";
import { useFormSubmit } from "melco-shared-logic";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { } from "../../../hooks/items/useShouldShowWarning";
import { useAddNewCoupon } from "../../../hooks/coupons/useAddNewCoupon";
import { DisplayNewCouponForm } from "./DisplayNewCouponForm";
import dayjs from "dayjs";


export type SubmitAction = "add";


export type AddNewCouponFormValueType = {
    type: number | undefined,
    code: string,
    description: string,

    value: number | undefined,
    product_code: string,
    start_date?: Date | null;
    end_date?: Date | null,
    usage_count: number | undefined,
    usage_type: number | undefined
};

type AddNewCouponFormProps = {

    referenceDrawer: DrawerType
    onCloseDrawer: (closeDrawer: boolean) => void;
};

export const AddNewCouponForm: React.FC<AddNewCouponFormProps> = ({
    referenceDrawer,
    onCloseDrawer
}) => {
    //  const { t } = useTranslation();
    //  const token = useUserToken();
    const addNewCoupon = useAddNewCoupon();
    const todayDateTime = dayjs().startOf("day").toDate();

    const onSubmit = async (
        values: AddNewCouponFormValueType,
        formikHelpers: FormikHelpers<AddNewCouponFormValueType>
    ) => {

        console.log(values)
        await onAddNewCoupon(values, formikHelpers, { isManuallyResettingForm: true });

    };



    const initialValues: AddNewCouponFormValueType = {
        type: undefined,
        code: "",
        description: "",

        value: undefined,
        product_code: "",
        start_date: todayDateTime,
        end_date: todayDateTime,
        usage_count: undefined,
        usage_type: undefined
    };

    const handleAddNewCoupon = async (
        values: AddNewCouponFormValueType,
        formikHelpers: FormikHelpers<AddNewCouponFormValueType>,
        options: {
        }
    ) => {
        const response = await addNewCoupon(values);
        if (response?.success) {
            formikHelpers.resetForm();
            onCloseDrawer(false);
        }
    };

    const formSubmitToAddNewCoupon = () => {

        return [
            async (
                values: AddNewCouponFormValueType,
                formikHelpers: FormikHelpers<AddNewCouponFormValueType>
            ) => {

                return handleAddNewCoupon(values, formikHelpers, {});
            },
            {
                translationOptions: {
                    batchNumber: 1,
                },
                translationPrefix: [
                    "coupons.actions",
                    "add_new",
                ].join("."),
                onError: () => {
                    // refetch entity from server
                },
            },
        ] as const;
    };

    const onAddNewCoupon = useFormSubmit(...formSubmitToAddNewCoupon());




    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}

            >

                <DirtyFormPrompt>
                    <DisplayNewCouponForm></DisplayNewCouponForm>

                </DirtyFormPrompt>
            </Formik>
        </>

    );
};
